



















































import usuarioModule from "@/store/modules/usuario-module";
//import TrakersLocationModule from "@/store/modules/trakerslocation-module";
import { Component, Vue, Watch } from "vue-property-decorator";
import DxDateBox from "devextreme-vue/date-box";
import DxTagBox from "devextreme-vue/tag-box";
import DxButton from "devextreme-vue/button";

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from "devextreme-vue/form";
import { API } from "@/shared/api";
import { centros } from "@/shared/dtos/centros";
import centrosModule from "@/store/modules/centros-module";
@Component({
  $_veeValidate: { validator: "new" },
  components: {
    DxDateBox,
    DxTagBox,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxButton,
  },
})
export default class GpsFichajes extends Vue {
  public center = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;
  //public value_usuarios = [];
  public datos = {
    fecha_desde: new Date(),
    fecha_hasta: new Date(),
    value_usuarios: [] as number[],
  };
  /* public markers = [
    { position: { lat: 10.0, lng: 10.0 } },
    { position: { lat: 11.0, lng: 11.0 } },
    // Agrega más puntos según necesites
  ];*/

  public selectedCentro: number | null = null; // Centro seleccionado
  public get centrosOptions() {
    return centrosModule.centroses; // Lista de centros
  }

  async created() {
    /* await usuarioModule.getusuarios();
    for (let index = 0; index < usuarioModule.usuarios.length; index++) {
      const element = usuarioModule.usuarios[index];
      this.datos.value_usuarios.push(Number.parseInt(element.id));
    }*/
    centrosModule.getcentroses();
  }
  get filteredMarkers() {
    // Filtrar los marcadores según el centro seleccionado
    if (this.selectedCentro) {
      const selectedMarker = this.markers.find(
        (marker) => marker.id === this.selectedCentro
      );
      if (selectedMarker) {
        this.center = selectedMarker.position; // Centrar el mapa en el marcador seleccionado
        return [selectedMarker];
      }
    }
    return this.markers; // Mostrar todos los marcadores si no hay selección
  }
  get markers() {
    var ubicaciones = centrosModule.centroses.map((x: centros) => {
      return {
        position: {
          lat: Number.parseFloat(x.latitud.replace(",", ".")),
          lng: Number.parseFloat(x.longitud.replace(",", ".")),
        },
        info: x.toJson(),
        nombre: x.nombre,
        id: x.id,
      };
    });
    this.calculateCenter(ubicaciones);
    return ubicaciones;
  }
  @Watch("datos")
  datos_usuarios() {
  }

  get usuarios() {
    return usuarioModule.usuarios;
  }

  public infoWindowOpened = false;

  public infoWindowOptions = {
    //@ts-ignore
    pixelOffset: new google.maps.Size(0, -30),
  };
  public infoWindowPosition: any = null;
  public infoWindowContent = {};
  openInfoWindow(index: number) {
    const marker = this.filteredMarkers[index];

    this.infoWindowPosition = marker.position;
    this.infoWindowContent = {
      info: marker.info,
      nombre: marker.nombre,
    };
    this.infoWindowOpened = true;
  }

  public getImagen(id: number) {
    return API.webApiBaseImages + id + ".png";
  }

  closeInfoWindow() {
    // set
    this.infoWindowOpened = false;
  }

  public async buscar() {
    await centrosModule.getcentroses();
  }
  public buscarBackGround() {
    //TrakersLocationModule.gettrackersBackGround();
  }
//https://serviequip.com/wp-content/uploads/2025/05/lidl.png
  customMarker() {
    return {
      url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png", // URL del ícono personalizado
      //@ts-ignore
      scaledSize: new google.maps.Size(50, 50), // Ajusta el tamaño del ícono}
    };
  }
  calculateCenter(locations: any[]) {
    if (locations.length === 0) return;

    let totalLat = 0;
    let totalLng = 0;
    locations.forEach((location) => {
      totalLat += location.position.lat;
      totalLng += location.position.lng;
    });

    const centerLat = totalLat / locations.length;
    const centerLng = totalLng / locations.length;

    this.center = { lat: centerLat, lng: centerLng };
  }
}
